import moment from 'moment';


export default function(dateStr) {
  let timestamp = Date.parse(dateStr)
  return moment(timestamp).format('MMM DD, YYYY')
}